import {
  FlexBox,
  JoonUIColor,
  Loader,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useEffect } from "react"
import { useRef } from "react"
import { useTranslation } from "react-i18next"

import DoterChatLogMessage from "./DoterChatLogMessage"
import { useDoterChatLogsQuery } from "../../../../networking/chatSessions/queries"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../../util/analytics"
import { useManageGameplay } from "../useManageGameplay"
const DoterChatHistory = () => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const { data, isLoading } = useDoterChatLogsQuery()
  const { child } = useManageGameplay()
  const { t } = useTranslation()

  // Scroll to bottom of chat history when load / new messages are added
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [data])

  useEffect(() => {
    trackAnalyticEvent(ANALYTIC_EVENTS.OPEN_DOTER_CHAT_HISTORY)
  }, [])

  if (isLoading)
    return (
      <FlexBox
        justify="center"
        align="center"
        style={{ padding: SPACING.space6 }}
      >
        <Loader color={JoonUIColor.icon.neutral} thickness={2} />
      </FlexBox>
    )

  if (!data) return null

  if (data.length === 0) {
    return (
      <FlexBox
        direction="column"
        gap={SPACING.space2}
        justify="center"
        align="center"
        style={{ padding: SPACING.space6 }}
      >
        <Typography variant="bodySmallBold">{t("DC_NO_MESSAGES")}</Typography>
        <Typography variant="bodySmall">
          {t("DC_TALK_TO_DOTER", { name: child?.name })}
        </Typography>
      </FlexBox>
    )
  }

  return (
    <FlexBox
      direction="column"
      wrap={false}
      gap={SPACING.space6}
      style={{ overflow: "auto", padding: SPACING.space4 }}
      ref={scrollRef}
    >
      {[...data].reverse().map((log, index) => (
        <DoterChatLogMessage key={index} log={log} />
      ))}
    </FlexBox>
  )
}

export default DoterChatHistory
